export default __webpack_public_path__ + "static/stocks-eca07bf339f6161f4094e32ef721e5a7.svg";